"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-260eec6a"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "mt-2 card" };
const _hoisted_2 = { class: "p-15" };
const _hoisted_3 = { class: "oplus-table-wrapper" };
const _hoisted_4 = { class: "oplus-table" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("td", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "全て")
], -1 /* HOISTED */));
const _hoisted_6 = { class: "h-100 d-flex flex-center" };
const _hoisted_7 = {
    class: "oplus-form-checkbox",
    for: "toggle-all"
};
const _hoisted_8 = ["checked"];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("td", null, null, -1 /* HOISTED */));
const _hoisted_10 = { class: "small-cell" };
const _hoisted_11 = { class: "h-100 d-flex flex-center c-hand handle" };
const _hoisted_12 = { class: "small-cell" };
const _hoisted_13 = { class: "h-100 d-flex flex-center" };
const _hoisted_14 = ["for"];
const _hoisted_15 = ["id", "onChange"];
const _hoisted_16 = { class: "text-left" };
const _hoisted_17 = { class: "small-cell" };
const _hoisted_18 = { class: "h-100 d-flex flex-center disabled-btn" };
const _hoisted_19 = { class: "small-cell" };
const _hoisted_20 = { class: "h-100 d-flex flex-center" };
const _hoisted_21 = ["for"];
const _hoisted_22 = ["id", "onChange"];
const _hoisted_23 = { class: "text-left" };
const vue_3 = require("vue");
const SortIcon_vue_1 = __importDefault(require("../../vue/icons/SortIcon.vue"));
const sortablejs_1 = __importDefault(require("sortablejs"));
const sortable_1 = require("../../model/v1/sortable");
const roles_1 = require("../../js/roles");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleRequiredByDay',
    setup(__props) {
        const role = (0, vue_3.inject)("roleView");
        // Todo: refs should be in a ViewModel
        const requiredByDayTable = (0, vue_3.ref)(null);
        const employees = (0, vue_3.ref)(role?.value.employeesData ?? []);
        const employeesOrder = (0, vue_3.ref)(role?.value.employeesOrder ?? []);
        const joinedEmployees = (0, vue_3.computed)(() => {
            let out = [];
            const joined = employees.value?.filter(e => e.joined);
            const empMap = new Map(employeesOrder.value.map((val, idx) => [val, idx]));
            if (employeesOrder.value.length) {
                out = joined.sort((a, b) => (empMap.get(a.id) ?? Infinity) - (empMap.get(b.id) ?? Infinity));
            }
            else {
                out = joined;
            }
            return out;
        });
        const unjoinedEmployees = (0, vue_3.computed)(() => {
            return employees.value?.filter(e => !e.joined) || [];
        });
        const isAllChecked = (0, vue_3.computed)(() => {
            return employees.value.every(e => e.joined);
        });
        const joinedUserIds = (0, vue_3.computed)(() => {
            return joinedEmployees.value.map(e => e.id);
        });
        function moveJoinedUser(oldIndex, newIndex) {
            if (oldIndex < 0 || oldIndex >= employeesOrder.value.length) {
                return;
            }
            if (newIndex < 0) {
                newIndex = 0;
            }
            if (newIndex >= employeesOrder.value.length) {
                newIndex = employeesOrder.value.length - 1;
            }
            const element = employeesOrder.value.splice(oldIndex, 1)[0];
            if (element) {
                employeesOrder.value.splice(newIndex, 0, element);
            }
        }
        // Todo: refs should be in a Presenter
        function toggleAllUsers(event) {
            if (!role) {
                return;
            }
            const target = event.target;
            const val = target.checked;
            for (const e of employees.value) {
                e.joined = val;
            }
            employeesOrder.value = [];
            if (val) {
                employeesOrder.value = employees.value.map(e => e.id);
            }
            (0, roles_1.handleRoleEmployeePositionUpdate)(role.value.id, joinedUserIds.value);
        }
        function handleChange(user) {
            if (!role) {
                return;
            }
            user.joined = !user.joined;
            const userIndex = employeesOrder.value.findIndex(eId => eId === user.id);
            if (user.joined && userIndex === -1) {
                employeesOrder.value.push(user.id);
            }
            if (!user.joined && userIndex !== -1) {
                employeesOrder.value.splice(userIndex, 1);
            }
            (0, roles_1.handleRoleEmployeePositionUpdate)(role.value.id, joinedUserIds.value);
        }
        (0, vue_3.onMounted)(() => {
            if (!requiredByDayTable.value) {
                return;
            }
            new sortablejs_1.default(requiredByDayTable.value, {
                ...sortable_1.roleTableSortableOptions,
                onEnd: async (event) => {
                    if (!role || event.oldDraggableIndex === event.newDraggableIndex || event.oldDraggableIndex === undefined || event.newDraggableIndex === undefined) {
                        return;
                    }
                    moveJoinedUser(event.oldDraggableIndex, event.newDraggableIndex);
                    await (0, roles_1.handleRoleEmployeePositionUpdate)(role.value.id, joinedUserIds.value);
                },
            });
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("table", _hoisted_4, [
                            (0, vue_2.createElementVNode)("tbody", {
                                ref_key: "requiredByDayTable",
                                ref: requiredByDayTable
                            }, [
                                (0, vue_2.createElementVNode)("tr", null, [
                                    _hoisted_5,
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                            (0, vue_2.createElementVNode)("label", _hoisted_7, [
                                                (0, vue_2.createElementVNode)("input", {
                                                    id: "toggle-all",
                                                    onChange: toggleAllUsers,
                                                    type: "checkbox",
                                                    checked: isAllChecked.value
                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_8)
                                            ])
                                        ])
                                    ]),
                                    _hoisted_9
                                ]),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(joinedEmployees.value, (user) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                        class: "joined-employees role-draggable",
                                        key: user.id
                                    }, [
                                        (0, vue_2.createElementVNode)("td", _hoisted_10, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                                (0, vue_2.createVNode)(SortIcon_vue_1.default)
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("td", _hoisted_12, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                                (0, vue_2.createElementVNode)("label", {
                                                    class: "oplus-form-checkbox",
                                                    for: `${user.id}-joined`
                                                }, [
                                                    (0, vue_2.createElementVNode)("input", {
                                                        id: `${user.id}-joined`,
                                                        onChange: ($event) => (handleChange(user)),
                                                        checked: "",
                                                        type: "checkbox"
                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_15)
                                                ], 8 /* PROPS */, _hoisted_14)
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("td", null, [
                                            (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)(user.name), 1 /* TEXT */)
                                        ])
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */)),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(unjoinedEmployees.value, (user) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                        class: "unjoined-employees",
                                        key: user.id
                                    }, [
                                        (0, vue_2.createElementVNode)("td", _hoisted_17, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                                (0, vue_2.createVNode)(SortIcon_vue_1.default)
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("td", _hoisted_19, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                                (0, vue_2.createElementVNode)("label", {
                                                    class: "oplus-form-checkbox",
                                                    for: `${user.id}-unjoined`
                                                }, [
                                                    (0, vue_2.createElementVNode)("input", {
                                                        id: `${user.id}-unjoined`,
                                                        onChange: ($event) => (handleChange(user)),
                                                        type: "checkbox"
                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_22)
                                                ], 8 /* PROPS */, _hoisted_21)
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("td", null, [
                                            (0, vue_2.createElementVNode)("span", _hoisted_23, (0, vue_2.toDisplayString)(user.name), 1 /* TEXT */)
                                        ])
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ], 512 /* NEED_PATCH */)
                        ])
                    ])
                ])
            ]));
        };
    }
});
